export default {
    toMoney(num) {
        return (num + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
    }
}